<template class="full-height">
  <div class="newwork-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth" :rules="rules">
          <el-form-item :label="funcName + '使用區域'" prop="countryAreaList">
            <el-cascader
              clearable
              v-model="form.countryAreaList"
              :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              style="width: 100%"
              placeholder="請選擇"
              filterable
              :options="travelAttractionsMenu"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item :label="funcName + '名稱'" prop="cardName">
            <el-input v-model="form.cardName"></el-input>
          </el-form-item>

          <el-form-item :label="funcName + '描述'" prop="description">
            <el-input type="textarea" :rows="10" v-model="form.description"></el-input>
          </el-form-item>

          <el-form-item :label="funcName + '效期'" prop="expiresDate">
            <el-date-picker
              style="width: 100%; font-size: 12px"
              v-model="form.expiresDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="選擇日期"
            />
          </el-form-item>

          <el-form-item :label="funcName + '單價'" prop="price">
            <el-input-number
              v-model.number="form.price"
              controls-position="right"
              :min="1"
              :max="99999"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="saveData">確 定</el-button>

        <el-button type="danger" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item label="網卡查詢">
          <el-input
            v-model="listQuery.qry"
            placeholder="輸入網卡名稱"
            @keyup.enter.native="getList"
          />
        </el-form-item>

        <el-form-item label="使用區域查詢">
          <el-cascader
            clearable
            v-model="listQuery.countryAreaList"
            :props="{ checkStrictly: true, expandTrigger: 'hover' }"
            style="width: 100%"
            placeholder="請選擇"
            filterable
            :options="travelAttractionsMenu"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="addData">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        class="networkcard-list"
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="使用區域" width="190">
          <template slot-scope="scope">
            <el-cascader
              disabled
              v-model="scope.row.countryAreaList"
              :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              style="width: 100%"
              placeholder="請選擇"
              filterable
              :options="travelAttractionsMenu"
            >
            </el-cascader>
          </template>
        </el-table-column>

        <el-table-column align="center" label="網卡名稱" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.cardName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" :label="'網卡描述'" width="700">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.description }}</span> -->
            <el-input :rows="6" type="textarea" disabled :value="scope.row.description"></el-input>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="'網卡效期'" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.expiresDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="'網卡金額'" width="150">
          <template slot-scope="scope">
            <span>${{ scope.row.price | currency }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteData(scope.row)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { saveCouponCategory } from '@/api/coupon'
import { MessageBox, Message } from 'element-ui'

import {
  getTravelAttractionsCascaderMenu,
  getNetworkCardList,
  saveNetworkCard,
  deleteNetworkCard,
} from '@/api/travel'

var defaultForm = {
  countryAreaList: [],
  cardName: '',
  description: '',
  expiresDate: '',
  price: 0,
}

export default {
  name: 'NetworkCard',
  components: {
    Pagination,
  },
  filters: {
    currency(v) {
      return v ? v.toLocaleString('en-US') : v
    },
    orderNoFilter(str) {
      return str.substring(0, 30)
    },
  },
  data() {
    return {
      funcName: '網卡',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      travelAttractionsMenu: [],
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        countryAreaList: [],
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
      rules: {
        countryAreaList: [
          {
            type: 'array',
            validator: function (rule, value, callback) {
              if (value.length == 0) {
                callback(new Error('請選擇使用區域'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        cardName: [
          {
            required: true,
            validator: function (rule, value, callback) {
              if (!value) {
                callback(new Error('請輸入網卡名稱'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        description: [
          {
            required: true,
            validator: function (rule, value, callback) {
              if (!value) {
                callback(new Error('請輸入網卡描述'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        expiresDate: [
          {
            required: true,
            validator: function (rule, value, callback) {
              if (!value) {
                callback(new Error('請輸入網卡效期'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        price: [
          {
            required: true,
            validator: function (rule, value, callback) {
              if (!value || value == 0) {
                callback(new Error('請輸入網卡金額'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  async created() {
    await this.getTravelAttractionsCascaderMenu()
    await this.getList()
  },
  methods: {
    async getTravelAttractionsCascaderMenu() {
      let resp = await getTravelAttractionsCascaderMenu()
      //只需要到國家
      if (resp.data) {
        resp.data.forEach(f => {
          if (f.children) {
            f.children.forEach(c => {
              c.children = null
            })
          }
        })
      }
      this.travelAttractionsMenu = resp.data
    },
    async deleteData(row) {
      if (!confirm(`確定要刪除網卡設定?`)) {
        return
      }
      this.listLoading = true
      try {
        let resp = await deleteNetworkCard({ id: row.id })
        await this.getList()
        Message({
          message: `資料處理完成。`,
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
    addData() {
      let vm = this
      vm.form = JSON.parse(JSON.stringify(defaultForm))
      vm.dialogVisible = true
    },
    editData(row) {
      let vm = this
      vm.form = row
      vm.dialogVisible = true
    },
    saveData() {
      if (!confirm(`確定要儲存網卡資料?`)) {
        return
      }
      let vm = this
      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          await saveNetworkCard(this.form)
          await vm.getList()
          vm.dialogVisible = false
          vm.dialogLoading = false
        } else {
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getNetworkCardList(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },
  },
}
</script>

<style scoped>
/deep/ .full-height {
  position: relative;
  height: 100%;
}

/deep/ .el-dialog__body {
  padding-top: 0px;
}

/deep/ .networkcard-list .el-input.is-disabled .el-input__inner {
  background-color: #fff6f694;
  border-color: #1256d1;
  color: #0137a3;
  cursor: not-allowed;
}

/deep/ .networkcard-list .el-input__suffix {
  display: none;
}

/deep/:disabled {
  color: blue !important;
}
</style>
